module.exports = __webpack_public_path__ + "static/media/soundcloud.fa27dd99.svg";